import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'
import {FormattedMessage} from "react-intl";

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`



function Table({ columns, data ,selectItem, username,userrole}) {
  // Use the state and functions returned from useTable to build your UI
 
 
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

 
  // Render the UI for your table
  return (
    <div className="tablewrapper" style={{height : "auto"}}>
      <table {...getTableProps()} >
        <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            <th style={{textAlign: 'center'}}>Select</th>
            {headerGroup.headers.map(column =>{
              return(
              <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>

                {column.render('Header')}
              </th>
            )})}
          </tr>
        ))}
        </thead>
        <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              <td style={{textAlign: 'center' }}>
                <input style={{width:'auto'}} type="radio" name="radio1" value={data[i]} onChange={()=>{selectItem(data[i]);}}
               
                />
              </td>
              {row.cells.map(cell => {
                if(cell.column.Header === 'Id'){
                   return <td style={{visibility: 'hidden'}}>{cell.render('Cell')}</td>
                }
                else if(cell.value === 'FreeAssessment'){
                  return <td {...cell.getCellProps()}>Free Analyzer</td>
                }
                else{
                  if(cell.column.Header === 'Reference ID' || cell.column.Header === 'Project Name' || cell.column.Header === 'Staging Project Name'){
                    return <td style={{textAlign: 'left' }} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  }else{
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  }
                }


              })}
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>

  )
}

function App(props) {
  let columns;
  if(props.userrole.includes('TRANSLATION_LEAD') || props.userrole.includes('DATA_ENGINEER')){
    columns = React.useMemo(
      () => [
       
        {
          Header: 'Project Name',
          accessor: 'projectName',
        },
        {
          Header: 'Application Name',
          accessor: 'applicationName',
        },
        {
          Header: 'STM',
          accessor: 'stm', // accessor is the "key" in the data
        },
        {
          Header: 'Version',
          accessor: 'currentversion', // accessor is the "key" in the data
        },
        {
          Header: 'Comments',
          accessor: 'comments', // accessor is the "key" in the data
        },
        {
          Header: 'Last Updated Time',
          accessor: 'lastUpdatedTime', // accessor is the "key" in the data
        },
        {
          Header: 'Updated By',
          accessor: 'updatedBy', // accessor is the "key" in the data
        }
        // ,
        // {
        //   Header: 'Source Status',
        //   accessor: 'sourcestatus', // accessor is the "key" in the data
        // }
      ],
      []
    );
  }else{
    columns = React.useMemo(
      () => [
        {
          Header: 'Project Name',
          accessor: 'projectName',
        },
        {
          Header: 'Application Name',
          accessor: 'applicationName',
        },
        {
          Header: 'STM',
          accessor: 'stm', // accessor is the "key" in the data
        },
        {
          Header: 'Current STM Version',
          accessor: 'currentversion', // accessor is the "key" in the data
        },
        {
          Header: 'Comments',
          accessor: 'comments', // accessor is the "key" in the data
        },
        {
          Header: 'Last Updated Time',
          accessor: 'lastUpdatedTime', // accessor is the "key" in the data
        },
        {
          Header: 'Updated By',
          accessor: 'updatedBy', // accessor is the "key" in the data
        }
        // ,
        // {
        //   Header: 'Source Status',
        //   accessor: 'sourcestatus', // accessor is the "key" in the data
        // }
      ],
      []
    );
  }


  // const data2 = React.useMemo(() => makeData(20), [])
  console.log('show the props in table')
  console.log(props)
  
  return (
    <Styles>
      {/* <br /> */}
      {/* <br />  */}
      <Table columns={columns} data={props.data} selectItem={props.selectItem} username={props.username} userrole={props.userrole}/>
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/ProjectManagement/table.js